<template>
  <div class="education">
    <div class="container">
      <div class="row mt-5">
        <div class="col-md-12 col-sm-12 mt-12">
          <div class="header_body">
            <div class="row mt-5">
              <div class="col-md-12 col-sm-12 mt-12">
                <img
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/MAINLogo-HD_H_21.01.05.png"
                  alt="hero" style="height:80px;margin-top:5%;" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-12 mt-12">
                <div class="header_text">
                  <h3>
                    Pay in 3 interest-free installments of<b style="color:#021FA3">
                      LKR {{ this.total_amount.toFixed(2) }}</b>
                    with your debit card
                  </h3>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-4 col-sm-12 mt-12">
                <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pie1-4.png" alt="“hero”"
                  style="height:100px;" />
                <div class="header_text">
                  <h3>
                    <b style="color:#021FA3"> LKR {{ this.split_amount }}</b>
                  </h3>
                  <h6>
                    Due Today
                  </h6>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 mt-12">
                <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pie2.png" alt="“hero”"
                  style="height:100px;" />
                <div class="header_text">
                  <h3>
                    <b style="color:#021FA3"> LKR {{ this.split_amount }}</b>
                  </h3>
                  <h6>
                    Due in 30 Days
                  </h6>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 mt-12">
                <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pie3.png" alt="“hero”"
                  style="height:100px;" />
                <div class="header_text">
                  <h3>
                    <b style="color:#021FA3"> LKR {{ this.split_amount }}</b>
                  </h3>
                  <h6>
                    Due in 60 Days
                  </h6>
                </div>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-12 col-sm-12 mt-12">
                <div class="get_started">
                  <div class="row">
                    <div class="col-md-12 col-sm-12 mt-12">
                      <div class="header_text_2">
                        <h4>Get Started with Koko</h4>
                      </div>

                      <div class="header_text_3">
                        <h6>
                          Koko is a ‘Buy Now, Pay Later’ app that lets you buy
                          what you love today & pay for it in 3 interest-free
                          instalments with a debit card.
                        </h6>
                      </div>
                      <div class="header_text_2" style="margin-top:7%;">
                        <h4>Register in less than 2 minutes</h4>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 col-sm-12 mt-12">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/Download(1).png"
                        alt="“hero”" style="height:100px;margin-top:5%;" />
                      <div class="header_text_3">
                        <h6>
                          Download the Koko App
                        </h6>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-12 mt-12">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/QuickStart.png"
                        alt="“hero”" style="height:100px;margin-top:5%;" />
                      <div class="header_text_3">
                        <h6>
                          Verify your phone number
                        </h6>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-12 mt-12">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/EasyPayment.png"
                        alt="“hero”" style="height:100px;margin-top:5%;" />
                      <div class="header_text_3">
                        <h6>
                          Enter your personal details
                        </h6>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-12 mt-12">
                      <img
                        src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/buyerprotection2.png"
                        alt="“hero”" style="height:100px;margin-top:5%;" />
                      <div class="header_text_3">
                        <h6>
                          Accept our Terms & Conditions
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="image">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/Koko_Smug%201.png" alt=""
                style="height:220px;" />
            </div>
            <div class="row" style="margin-top:5%;">
              <div class="bodytext">
                <b>
                  <h4 style="font-weight: 600;">
                    Just Select
                    <img
                      src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/MAINLogo-HD_H_21.01.05.png"
                      alt="“hero”" style="height:40px;" />
                    at Checkout
                  </h4>
                </b>
              </div>

              <div class="bodytext2">
                <p>
                  Get access to a bigger spending limit in 24 hours by uploading
                  your NIC, latest salary slip, & latest utility bill.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Education",
  components: {},
  props: {},
  data() {
    return {
      split_amount: "",
      total_amount: "",
    };
  },
  computed: {},
  created() {
    let parameters = this.$route.query;
    console.log("__ROUTER_PARAMS :", parameters);

    let Amount = this.$route.query.Amount;

    this.split_amount = Amount;
    this.total_amount = this.split_amount * 3;

    console.log("__TOTAL : ", this.total_amount);
    console.log("__SPLIT_AMOUNT : ", this.split_amount);
    // console.log("__FORMATED_AMOUNT :", this.formated_amount);
  },
};
</script>

<style scoped>
.image {
  text-align: left;
  margin-left: 0%;
  margin-top: -10%;
}
.get_started {
  height: 100%;
  border-radius: 20px;
  background-color: #f3eee7;
  /* margin: 10%; */
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 3%;
}
.header_text_2 {
  font-family: Lato;
  color: black;
  margin-top: 6%;
  font-weight: 600;
  margin-left: 2%;
  margin-right: 2%;
}
.header_text_3 {
  font-family: Lato;
  color: black;
  margin-top: 2%;
  margin-left: 5%;
  margin-right: 5%;
}
.bodytext {
  font-family: Lato;
  color: black;
}
.bodytext2 {
  font-family: Lato;
  color: black;
}
.header_text {
  color: black;
  text-align: center;
  margin-left: 5%;
  margin-right: 5%;
  font-family: Lato;
}
.header_body {
  text-align: center;
  background-color: white;
  border-radius: 40px;
  margin-bottom: 5%;
}

.body_class {
  background-color: white;
}
.div#app {
  background-color: white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 56px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;
  text-align: justify;
  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}
.sectionKoko2 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

.bigSpecImgHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  /* line-height: 29px; */

  color: #393939;
}

.zcwf_col_lab {
  color: #393939;
  opacity: 0.8;
}

.maxWidthDefiner {
  /*max-width: 250px;*/
  margin-top: 30px;
}

.maxWidthDefiner3 {
  max-width: 300px;
  margin-top: 30px;
}

.kokoWebButtons {
  background-color: #000000;
  border: 0;
  height: 40px;
  width: 300px;
  font-weight: bold;
}

.headerbox {
  background-color: white;
  border-radius: 16px;
  width: 90%;
  margin-left: 5%;
  height: 300px;
  margin-top: 5%;
}
.headerbox_body {
  margin-left: 5%;
  padding-top: 5%;
  height: 450px;
  margin-right: 5%;
}
.mobile {
  display: none;
}
.header_imge {
  max-width: 137%;
  margin-top: -24%;
  margin-left: -70%;
}

@media only screen and (max-width: 600px) {
  .headerbox {
    background-color: white;
    border-radius: 16px;
    width: 90%;
    margin-left: 5%;
    height: 330px;
  }
  .mobile {
    display: block;
  }

  .pc {
    display: none;
  }
  .header_imge {
    max-width: 100%;
    margin-top: -10%;
    margin-left: -6%;
  }
}
</style>
